import React from "react";
import gql from "graphql-tag";
import { LocationContext } from "@reach/router";
import { useMutation } from "react-apollo";
import queryString from "query-string";
import {
  EButtonIconBox,
  ELinkModalBuyButton,
} from "@organisms/linkModalComponents/BuyButton/BuyButtonEmotion";
import { GiftcardIntentCreateInput } from "@types";
import { useStoreAppValue } from "@hooks";
import { RailsUrl, renderIf, Bugsnag } from "@services";
import { Box, Image } from "@atoms";
import {
  GiftcardIntentCreateMutation,
  GiftcardIntentCreateMutationVariables,
} from "./__generated__/GiftcardIntentCreateMutation";

// == Types ================================================================

interface IProps {
  onLinkClick: () => void;
  createIntentInput: GiftcardIntentCreateInput;
  locationContext: LocationContext;
  campaignId?: string;
  fundraiserId?: string;
  linkId: string;
  disabled: boolean;
}

// == Constants ============================================================

const GIFTCARD_BUTTON_IMAGE =
  "https://d2wkegjj8g6j4.cloudfront.net/images/site/shop/link-modal-giftcard-v2.png";

// == Component ============================================================

export default function NewCheckoutBuyButton({
  campaignId,
  fundraiserId,
  onLinkClick,
  createIntentInput,
  locationContext,
  linkId,
  disabled,
}: IProps) {
  const { currentUser } = useStoreAppValue();

  const userNeedsSignUp = !currentUser && !campaignId && !fundraiserId;
  const createIntentUrl = () => {
    const { deviceAttributes, ...rest } = createIntentInput;
    const params = queryString.stringify({
      ...rest,
      deviceAttributes: JSON.stringify({ ...deviceAttributes }),
    });

    return RailsUrl.createIntentUrl({ params, campaignId });
  };

  const { tinyLinkKey } = locationContext.location.state;

  const onClick = (e) => {
    if (disabled) {
      e.preventDefault();
    } else {
      return currentUser && onLinkClick();
    }
    return null;
  };

  const checkoutHref = () => {
    if (disabled) return "";
    if (userNeedsSignUp) {
      return `${RailsUrl.createTeamUrl()}?s=${tinyLinkKey}`;
    }
    return createIntentUrl();
  };

  return (
    <ELinkModalBuyButton
      as="a"
      href={checkoutHref()}
      target="_blank"
      userNeedsSignUp={userNeedsSignUp}
      onClick={(e) => onClick(e)}
      variant={disabled ? "disabledSolid" : "primary"}
    >
      {renderIf(!userNeedsSignUp)(
        <EButtonIconBox>
          <Box>
            <Image alt="Giftcard" src={GIFTCARD_BUTTON_IMAGE} />
          </Box>
        </EButtonIconBox>
      )}
      {userNeedsSignUp ? "Sign Up And Register Your Team To Shop" : "Buy Now"}
    </ELinkModalBuyButton>
  );
}

// == Styles ===============================================================
